export const form = {
  data () {
    return {
    }
  },
  methods: {
    __formInvalid (updates) {
      this.$v.$touch()
      if (this.$v.$invalid) {
        console.log('form invalid')
        return true
      } else if (updates && Object.keys(updates).length === 0) {
        console.log(updates)
        console.log('nothing changed')
        return true
      } else {
        return false
      }
    },
    __formClone (form, fields) {
      let clone = {}
      if (!form) return clone

      if (fields) {
        //console.log(fields)
        clone = fields.reduce((acc, key) => {
          acc[key] = form[key]
          //console.log('acc', acc)
          return acc
        }, {})
      } else {
        clone = Object.assign({}, form)
      }
      return clone
    },
    __formUpdates (original, form, fields) {
      return fields.reduce((updates, key) => {
        //console.log(`${key}: ${original[key]} !== ${form[key]}`)
        if (original[key] !== form[key]) {
          updates[key] = form[key]
        }
        return updates
      }, {})
    }
  }
}